import { SET_CALENDAR_EVENTS } from '../../actionConstants';

import { generateSkeletonCalendarPlaceholders } from './utils';

export const showCalendarPlaceholders = (dispatch, queryParams) => {
  const skeletonPlaceholders =
    generateSkeletonCalendarPlaceholders(queryParams);
  dispatch({
    type: SET_CALENDAR_EVENTS,
    events: skeletonPlaceholders,
  });
};
